module.exports = __webpack_public_path__ + "img/center-height.a3d4800a.svg";